import { APP_LINK, APP_ONE_LINK, DEEP_LINK_MARKET } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { isIOS, openDialog } from './utils';
import '@/src/styles/base/_reset.scss';
import '@/src/styles/base/_base.scss';
import '@/src/styles/base/_common.scss';
import '@/src/styles/pages/_etc.scss';
const goToWeb = () => {
    window.location.href = '/';
};
const goAppLink = () => {
    if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', goToWeb);
    }
    else if (window.location.search.includes('pid=gdn')) {
        const GDN_LINK = `${APP_ONE_LINK}?pid=gdn&c=bataa_pa_gdn_skt&is_retargeting=true` +
            `&af_ios_url=${APP_LINK}&af_android_url=${DEEP_LINK_MARKET}`;
        window.open(GDN_LINK, '_self');
    }
    else {
        window.open(`${DEEP_LINK_MARKET}`, '_self');
    }
};
const initialize = () => {
    firebaseInit();
    const btn = document.getElementById('download-btn');
    if (btn) {
        btn.addEventListener('click', goAppLink);
    }
};
initialize();
